<template>
  <div class="referral">
    <div class="subheading grey--text ma-6 mb-0"><h5>Account settings</h5></div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6">
        <v-card max-width="600" class="pa-6 custom-card" flat>
          <UserEditDetails />
          <UserEditPassword />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UserEditDetails from "@/components/user/UserEditDetails";
import UserEditPassword from "@/components/user/UserEditPassword";
export default {
  components: { UserEditDetails, UserEditPassword },
  data() {
    return {};
  },
};
</script>
